// const { createSlice } = require('@reduxjs/toolkit')

import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  devise: {
    to_eur: '',
    Devise: 'EUR',
    Code_iso: 'EUR',
    Designation: 'Euro européen',
    Description: 'Euro',
  },
}
const deviseSlice = createSlice({
  name: 'devise',
  initialState,
  reducers: {
    setSitedevise: (state, action) => {
      state.devise = action.payload
    },
  },
})

export const { setSitedevise } = deviseSlice.actions
export default deviseSlice.reducer
